import React, { useState } from "react";
import algoliasearch from "algoliasearch/lite";
import {
  InstantSearch,
  Configure,
  Snippet,
  connectSearchBox,
  connectHits,
  Hits,
} from "react-instantsearch-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import Link from 'gatsby-link';


import "../styles/SiteSearch.scss";

const appId = process.env.GATSBY_ALGOLIA_APP_ID;
const searchKey = process.env.GATSBY_ALGOLIA_SEARCH_KEY;

const SEARCH_RESULTS_LIMIT = 5;

const SearchBox = ({ currentRefinement, refine, updateSearchQuery, intl }) => (
  <form
    className="control"
    noValidate
    action=""
    role="search"
    onSubmit={(e) => e.preventDefault()}
  >
    
    <input
      className="form-input"
      type="search"
      placeholder="What questions do you have about immigration?"
      placeholder={intl.formatMessage({ id: "searchPlaceholder" })}
      value={currentRefinement}
      onChange={(event) => {
        refine(event.currentTarget.value);
        updateSearchQuery(event.currentTarget.value);
      }}
    />
  </form>
);


const SearchHits = ({ hits, locale }) =>
  hits && hits.length > 0 ? (
    <ul className="menu hits-menu">
      {hits
        .map((hit) => (
          <li className="menu-item" key={hit.objectID}>
            <Link to={`/${locale}/tips/${hit.slug}`}>
              <h4>{hit.title} →</h4>
              <div className="result__snippet">
                <Snippet attribute="content" hit={hit} tagName="u" />
              </div>
            </Link>
          </li>
        ))
        .slice(0, SEARCH_RESULTS_LIMIT)}
    </ul>
  ) : (
    <ul className="menu hits-menu">
      <FormattedMessage id="noSearchResults" />
    </ul>
  );



const CustomSearchBox = injectIntl(connectSearchBox(SearchBox));
const CustomHits = connectHits(SearchHits);

const SiteSearch = ({ intl }) => {
  const [query, setQuery] = useState("");

  const locale = intl.locale;
  console.log(locale);

  return appId && searchKey ? (
    <div className="site-search">
      <InstantSearch
        searchClient={algoliasearch(appId, searchKey)}
        indexName={
          locale !== "en-US" ? `site_search_${locale}` : "site_search"
        }
        resultsState={[]}
      >
        <CustomSearchBox updateSearchQuery={(e) => setQuery(e)} />

        {(query || "").length > 0 && (
          <React.Fragment>
            <Configure
              attributesToSnippet={["content:10"]}
              snippetEllipsisText={`…`}
              analytics={true}
            />
            <CustomHits locale={locale} />
          </React.Fragment>
        )}
      </InstantSearch>

      {query && (
        <div className="search-by is-pulled-right">
          {/* <img
            width="100"
            height="20"
            src={require("../../img/brand/algolia.svg")}
          /> */}
        </div>
      )}
    </div>
  ) : (
    <React.Fragment />
  );
};

export default injectIntl(SiteSearch);